import { ApiError } from "../api/client";

export const signupBusinessCategories = [
  "Photography Studio",
  "Furniture and Mattress Retail",
  "Bridal Wear / Boutique",
  "Bridal Jewellery Rental",
  "Salon / Bridal Makeup / Skin Clinic",
  "Kids Wear",
  "Interior Design / Modular Kitchen",
  "Wedding Decoration / Event Planning",
  "Cakes / Bakery",
  "Real Estate",
  "Used Cars",
  "Car Rental",
  "Travel Agency",
  "Catering",
  "Printing & Signage",
  "Return Gifts / Hampers",
  "General Business",
] as const;

export const signupLeadSources = [
  "Instagram",
  "Facebook",
  "Instagram + Facebook",
  "WhatsApp",
  "Instagram + WhatsApp",
  "Website",
  "Phone / Walk-in",
  "Manual / Excel Upload",
  "Other",
] as const;

export function normalizePhone(value: string, countryCode = "IN"): string {
  let clean = String(value || "").replace(/[^\d+]/g, "");
  if (clean.startsWith("00")) clean = `+${clean.slice(2)}`;
  if (clean && !clean.startsWith("+")) {
    if (countryCode === "AE" && clean.startsWith("0") && clean.length >= 8 && clean.length <= 10) clean = `+971${clean.slice(1)}`;
    else if (countryCode === "AE" && clean.length >= 8 && clean.length <= 9) clean = `+971${clean}`;
    else if (countryCode === "IN" && clean.length === 10) clean = `+91${clean}`;
  }
  return clean;
}

export function isValidPhone(value: string): boolean {
  return /^\+[1-9]\d{9,14}$/.test(value);
}

export function normalizeEmail(value: string): string {
  return String(value || "").trim().toLowerCase();
}

export function isValidEmail(value: string): boolean {
  return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(normalizeEmail(value));
}

export function passwordRules(password: string) {
  const value = String(password || "");
  return [
    { key: "length", label: "8+ characters", ok: value.length >= 8 },
    { key: "upper", label: "Uppercase", ok: /[A-Z]/.test(value) },
    { key: "lower", label: "Lowercase", ok: /[a-z]/.test(value) },
    { key: "number", label: "Number", ok: /\d/.test(value) },
    { key: "special", label: "Special symbol", ok: /[^A-Za-z0-9]/.test(value) },
  ];
}

export function authError(error: unknown): string {
  const message = error instanceof Error ? error.message : "The request could not be completed";
  const requestId = error instanceof ApiError ? error.payload.request_id : undefined;
  return `${message}${requestId ? ` Request ID: ${requestId}` : ""}`;
}
